import { render } from "./tip.vue?vue&type=template&id=a87f26f0&scoped=true&lang=pug"
import script from "./tip.vue?vue&type=script&setup=true&lang=js"
export * from "./tip.vue?vue&type=script&setup=true&lang=js"

import "./tip.vue?vue&type=style&index=0&id=a87f26f0&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87f26f0"]])

export default __exports__